export default __webpack_public_path__ + "static/media/subscribe.7faa2822.png";